import { default as calculationaR0sTcIpeDMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/layers/travel/pages/calculation.vue?macro=true";
import { default as detailc8JFOeZ3G7Meta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/layers/travel/pages/detail.vue?macro=true";
import { default as inquiry712W6ujoykMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/layers/travel/pages/inquiry.vue?macro=true";
import { default as _91_91type_93_93TTSaqJSRHiMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/pages/kurzy/[[company]]/[[type]].vue?macro=true";
import { default as offer_45list6VeGnW5oWFMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/layers/travel/pages/offer-list.vue?macro=true";
import { default as testing5DCrIHN8hBMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/pages/testing.vue?macro=true";
import { default as thankyou6qobw0gcu1Meta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/layers/travel/pages/thankyou.vue?macro=true";
import { default as upselldkkppFYaBmMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/layers/travel/pages/upsell.vue?macro=true";
import { default as zadost2ny0qZ45HGMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/zadost?macro=true";
import { default as thankavmwdld4yCMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/thank?macro=true";
import { default as srovnani9tOTk5XuhBMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani?macro=true";
import { default as pageVWCjQwXGmAMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page?macro=true";
import { default as headers_45testrNbIm0zbXHMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/headers-test?macro=true";
import { default as homepagecYuzQANF2ZMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/homepage?macro=true";
import { default as articlezvcPk5FI9EMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/article?macro=true";
import { default as document_45patternsnLmI0tc46sMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/document-patterns?macro=true";
import { default as tagVy8qQYdB4HMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/tag?macro=true";
import { default as autorfl8kze166PMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/autor?macro=true";
import { default as categoryAkCx3XgeYzMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/category?macro=true";
import { default as sectiontjPcfQg4z3Meta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/section?macro=true";
import { default as all_45articlesnc07p41xfpMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/all-articles?macro=true";
import { default as categoryGIPjB0PLMAMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/category?macro=true";
import { default as articleVauqi18TBwMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/article?macro=true";
import { default as sectionBr4EOye17UMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section?macro=true";
import { default as contactL8GawbpU1aMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/contact?macro=true";
import { default as car_45insurance_45terminationvTW2LFE726Meta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/car-insurance-termination?macro=true";
import { default as calculationY8hfKrKC7XMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/calculation?macro=true";
import { default as thank_45youSwb47EAokGMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/thank-you?macro=true";
import { default as detailaS1BeMWnsyMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/detail?macro=true";
import { default as inquiryH4oTUV7riiMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/inquiry?macro=true";
import { default as offer_45listPhGEqkXLszMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/offer-list?macro=true";
import { default as calculation9eqSB9tcWZMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/calculation?macro=true";
import { default as thank_45youv1oKATtV5SMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/thank-you?macro=true";
import { default as inquiryZP6coi4AD5Meta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/inquiry?macro=true";
import { default as offer_45listEqdHRkXuVGMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/offer-list?macro=true";
import { default as detailDmTj8KbJdhMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/detail?macro=true";
import { default as offerzpqTsG2ES0Meta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/offer?macro=true";
import { default as inquiryLhiiRcC7ZbMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/inquiry?macro=true";
import { default as thank_45youZZp9q2MtzZMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/thank-you?macro=true";
import { default as calculationVH4iiVyWk2Meta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/energo/pages/calculation?macro=true";
import { default as offer_45listvQGdHVlem8Meta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/energo/pages/offer-list?macro=true";
import { default as thank_45youGqyY5BkunsMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/energo/pages/thank-you?macro=true";
import { default as inquiry_45onlineh2BST3W55HMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-online?macro=true";
import { default as detailbTdaCPbMMTMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/energo/pages/detail?macro=true";
import { default as inquiry_45phone1URMqO4weSMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-phone?macro=true";
import { default as inquiry_45custom_45offerpIog5YplgmMeta } from "/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-custom-offer?macro=true";
export default [
  {
    name: "calculation",
    path: "/cestovni-pojisteni/zadani/:leadId?",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/layers/travel/pages/calculation.vue")
  },
  {
    name: "detail",
    path: "/cestovni-pojisteni/:leadId?/detail/:offerId?",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/layers/travel/pages/detail.vue")
  },
  {
    name: "inquiry",
    path: "/cestovni-pojisteni/sjednani/:leadId?",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/layers/travel/pages/inquiry.vue")
  },
  {
    name: "kurzy-company-type",
    path: "/kurzy/:company?/:type?",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/pages/kurzy/[[company]]/[[type]].vue")
  },
  {
    name: "offer-list",
    path: "/cestovni-pojisteni/nabidka/:leadId?",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/layers/travel/pages/offer-list.vue")
  },
  {
    name: "testing",
    path: "/testing",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/pages/testing.vue")
  },
  {
    name: "thankyou",
    path: "/cestovni-pojisteni/dekujeme/:leadId?",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/layers/travel/pages/thankyou.vue")
  },
  {
    name: "upsell",
    path: "/cestovni-pojisteni/upsell/:leadId?",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/layers/travel/pages/upsell.vue")
  },
  {
    name: zadost2ny0qZ45HGMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/zadost",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/zadost")
  },
  {
    name: thankavmwdld4yCMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/:thank(dekujeme|zamitnuto-partner|zamitnuto)",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/thank")
  },
  {
    name: srovnani9tOTk5XuhBMeta?.name,
    path: "/pujcky-a-uvery/pujcka-na-miru/srovnani",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani")
  },
  {
    name: pageVWCjQwXGmAMeta?.name,
    path: "/:all(.*)*",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: headers_45testrNbIm0zbXHMeta?.name,
    path: "/headers-test",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/headers-test")
  },
  {
    name: homepagecYuzQANF2ZMeta?.name,
    path: "/clanky",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/homepage")
  },
  {
    name: articlezvcPk5FI9EMeta?.name,
    path: "/clanky/:article(.*)*",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/article")
  },
  {
    name: document_45patternsnLmI0tc46sMeta?.name,
    path: "/clanky/vzory-dokumentu",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/document-patterns")
  },
  {
    name: tagVy8qQYdB4HMeta?.name,
    path: "/clanky/tag/:slug(.*)*",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/tag")
  },
  {
    name: autorfl8kze166PMeta?.name,
    path: "/clanky/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/autor")
  },
  {
    name: categoryAkCx3XgeYzMeta?.name,
    path: "/clanky/:category(kategorie)",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/category")
  },
  {
    name: sectiontjPcfQg4z3Meta?.name,
    path: "/clanky/:category(kategorie)/:section(pojisteni|hypoteky|pujcky|energie|mobilni-tarify|osobni-finance)",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/section")
  },
  {
    name: all_45articlesnc07p41xfpMeta?.name,
    path: "/clanky/all-articles",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/all-articles")
  },
  {
    name: pageVWCjQwXGmAMeta?.name,
    path: "/slovnik-pojmu",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: categoryGIPjB0PLMAMeta?.name,
    path: "/slovnik-pojmu/:category(elektrina|hypoteky|penzijni-sporeni|plyn|povinne-ruceni|uvery|pujcky)",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/category")
  },
  {
    name: articleVauqi18TBwMeta?.name,
    path: "/slovnik-pojmu/:category(elektrina|hypoteky|penzijni-sporeni|plyn|povinne-ruceni|uvery|pujcky)/:id(.*)*",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/article")
  },
  {
    name: sectionBr4EOye17UMeta?.name,
    path: "/radce/",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: sectionBr4EOye17UMeta?.name,
    path: "/radce/:slug(.*)",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: contactL8GawbpU1aMeta?.name,
    path: "/kontakt",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/contact")
  },
  {
    name: car_45insurance_45terminationvTW2LFE726Meta?.name,
    path: "/zruseni-povinneho-ruceni-zmena-pojistovny",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/car-insurance-termination")
  },
  {
    name: calculationY8hfKrKC7XMeta?.name,
    path: "/internet/kalkulace",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/calculation")
  },
  {
    name: thank_45youSwb47EAokGMeta?.name,
    path: "/internet/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/thank-you")
  },
  {
    name: detailaS1BeMWnsyMeta?.name,
    path: "/internet/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/detail")
  },
  {
    name: inquiryH4oTUV7riiMeta?.name,
    path: "/internet/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/inquiry")
  },
  {
    name: offer_45listPhGEqkXLszMeta?.name,
    path: "/internet/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/offer-list")
  },
  {
    name: calculation9eqSB9tcWZMeta?.name,
    path: "/mobilni-tarify/kalkulace",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/calculation")
  },
  {
    name: thank_45youv1oKATtV5SMeta?.name,
    path: "/mobilni-tarify/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/thank-you")
  },
  {
    name: inquiryZP6coi4AD5Meta?.name,
    path: "/mobilni-tarify/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/inquiry")
  },
  {
    name: offer_45listEqdHRkXuVGMeta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/offer-list")
  },
  {
    name: detailDmTj8KbJdhMeta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/detail")
  },
  {
    name: offerzpqTsG2ES0Meta?.name,
    path: "/balicky-sluzeb/priklad-nabidky",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/offer")
  },
  {
    name: inquiryLhiiRcC7ZbMeta?.name,
    path: "/balicky-sluzeb/sjednani-nabidky",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/inquiry")
  },
  {
    name: thank_45youZZp9q2MtzZMeta?.name,
    path: "/balicky-sluzeb/potvrzeni-objednavky",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/thank-you")
  },
  {
    name: calculationVH4iiVyWk2Meta?.name,
    path: "/energie/kalkulace-:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/energo/pages/calculation")
  },
  {
    name: offer_45listvQGdHVlem8Meta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/energo/pages/offer-list")
  },
  {
    name: thank_45youGqyY5BkunsMeta?.name,
    path: "/energie/prehled-vaseho-pozadavku/:leadId?",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/energo/pages/thank-you")
  },
  {
    name: inquiry_45onlineh2BST3W55HMeta?.name,
    path: "/energie/sjednani-online/:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-online")
  },
  {
    name: detailbTdaCPbMMTMeta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId/detail/:tariffId",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/energo/pages/detail")
  },
  {
    name: inquiry_45phone1URMqO4weSMeta?.name,
    path: "/energie/sjednani-po-telefonu/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-phone")
  },
  {
    name: inquiry_45custom_45offerpIog5YplgmMeta?.name,
    path: "/energie/nabidka-na-miru",
    component: () => import("/codebuild/output/src1108604441/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-custom-offer")
  }
]